import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

import { CompanySelectWrapper } from '../CommonStyled/CompanySelect/styled';
import { PersonSelectWrapper } from '../CommonStyled/PersonSelect/styled';
import {
  ContactDrawerFirstStepListItemCheckbox,
  ContactDrawerFirstStepListItemCheckboxBackground,
  ContactDrawerFirstStepListItemCheckboxContainer,
} from '../Drawers/Contact/ContactSteps/ContactFirstStep/styled';
import {
  ResourceCardExtraInformationWrapper,
  ResourceCardWrapper,
} from '../Resources/ResourceCard/styled';

export const ResourceSubmissionStepsWrapper = styled.div`
  ${({ theme }) =>
    theme.isUnpublishDialogOpen
      ? `
    filter: blur(10px);
    pointer-events: none;
    user-select: none;
    overflow: hidden;
  `
      : ''}
`;

export const ResourceSubmissionWrapper = styled.main`
  width: 100%;

  padding: 32px;

  background: ${({ theme }) =>
    theme.fromBestOf2025 || theme.existingResource ? 'none' : '#f7f7f7'};

  min-height: 100vh;

  position: relative;

  ${BREAKPOINTS.tablet} {
    padding: 16px;
  }
`;

export const ResourceSubmissionContentBlurBackground = styled.img.attrs({
  src: '/images/resource-submission/background-blur.jpg',
})`
  width: 100%;
  max-height: 626px;
  object-fit: fill;

  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;

  ${BREAKPOINTS.tablet} {
    top: 0px;
  }
`;

export const ResourceSubmissionSectionTitle = styled.h3`
  font-weight: 400;
  font-size: 32px;
  line-height: normal;

  color: #000000;
`;

export const ResourceSubmissionContainer = styled.div`
  width: 100%;
  max-width: 1100px;

  display: flex;
  flex-direction: column;
  gap: 50px;

  margin: 0 auto;

  padding-bottom: 164px;

  position: relative;
`;

export const ResourceSubmissionTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  ${BREAKPOINTS.tablet} {
    align-items: center;
    gap: 8px;
  }
`;

export const ResourceSubmissionTitle = styled.h3`
  font-weight: 400;
  font-size: 32px;
  line-height: normal;

  color: #000000;
`;

export const ResourceSubmissionBestOfTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ResourceSubmissionBestOfTitle = styled.h3`
  font-weight: 400;
  font-size: 64px;
  line-height: normal;

  color: #000000;

  ${BREAKPOINTS.tablet} {
    font-size: 32px;
  }
`;

export const ResourceSubmissionBackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
`;

export const ResourceSubmissionFieldTitle = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;

  color: #000000;
`;

interface ResourceSubmissionFieldSubtitleProps {
  isError?: boolean;
}

export const ResourceSubmissionFieldSubtitle = styled.span<ResourceSubmissionFieldSubtitleProps>`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: ${({ isError }) => (isError ? 'var(--color-error)' : '#000000')};
`;

export const ResourceSubmissionFieldHint = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourceSubmissionFieldLabel = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourceSubmissionFormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 69px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    gap: 32px;
  }
`;

export const ResourceSubmissionFormFieldsWrapper = styled.div`
  width: 70%;

  display: flex;
  flex-direction: column;
  gap: 32px;

  ${BREAKPOINTS.tablet} {
    width: 100%;
  }
`;

export const ResourceSubmissionFormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ResourceSubmissionFormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > [name='short_description'] {
    min-height: 76px;
  }

  & > [name='long_description'],
  & > [name='impact_metrics'] {
    min-height: 122px;
  }

  & ${PersonSelectWrapper} {
    min-height: 56px;
  }

  & ${CompanySelectWrapper} {
    min-height: 56px;
  }
`;

export const ResourceSubmissionFormFieldTagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

interface ResourceSubmissionFormFieldTagContainerProps {
  active: boolean;
}

export const ResourceSubmissionFormFieldTagContainer = styled.div<ResourceSubmissionFormFieldTagContainerProps>`
  display: flex;
  align-items: center;

  padding: 4px 8px;

  border-radius: 26px;
  border: 1px solid ${({ active }) => (active ? 'var(--color-data-skill-background)' : '#323f5d')};

  cursor: pointer;

  background: ${({ active }) => (active ? 'var(--color-data-skill-background)' : 'transparent')};
`;

export const ResourceSubmissionFormFieldTagLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: #323f5d;
`;

// RESOURCE CARD
export const ResourceSubmissionCardContainer = styled.div`
  max-width: 30%;
  height: fit-content;

  position: sticky;
  top: calc(var(--navbar-height) + 32px);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  & ${ResourceCardWrapper} {
    width: 293px;

    & ${ResourceCardExtraInformationWrapper} {
      display: none;
    }
  }

  ${BREAKPOINTS.tablet} {
    max-width: unset;
    flex-direction: column-reverse;

    & > div {
      width: 100%;
    }

    position: relative;
  }
`;

export const ResourceSubmissionCardSubtitle = styled.span`
  width: 271px;

  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

// FILE INPUT
export const ResourceSubmissionFieldFileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 32px;
  gap: 40px;

  border-radius: 8px;
  border: 1px dashed rgba(135, 135, 135, 0.3);
  background: #f7f7f7;

  cursor: pointer;
`;

export const ResourceSubmissionFieldFileInputButton = styled.div`
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 16px 48px 16px 40px;

  border-radius: 100px;
  border: 2px solid #000000;
`;

export const ResourceSubmissionFieldFileInputButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: #000000;
`;

export const ResourceSubmissionFieldFileInputSubtitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

//CHECKBOX
export const ResourceSubmissionFieldCheckboxWrapper = styled.div<{ $hidden?: boolean }>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ResourceSubmissionFieldCheckboxContainer = styled(
  ContactDrawerFirstStepListItemCheckboxContainer
)``;
export const ResourceSubmissionFieldCheckbox = styled(ContactDrawerFirstStepListItemCheckbox)``;

export const ResourceSubmissionFieldCheckboxBackground = styled(
  ContactDrawerFirstStepListItemCheckboxBackground
)``;

export const ResourceSubmissionFieldCheckboxLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: #000000;
`;

//SUBMIT
export const ResourceSubmissionFieldSubmitButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 16px;
  margin: 0 auto;

  border-top: 1px solid rgba(209, 178, 178, 0.4);
  background: rgba(255, 255, 255, 0.1);

  ${BREAKPOINTS.tablet} {
    width: 100%;

    position: sticky;
    bottom: 0px;

    background: #ffffff;
    z-index: 1000;
  }
`;

export const ResourceSubmissionSubmitError = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 12px 16px;

  border-radius: 12px;
  background: rgba(221, 53, 46, 0.1);
  color: var(--color-text);
  font-size: 14px;
  line-height: 1.4;
`;

export const ResourceSubmissionFieldSubmitOneLinerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;

  gap: 8px;
`;

export const ResourceSubmissionFieldSubmitOneLineLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: #000000;
`;

export const ResourceSubmissionFieldSubmitButton = styled.button`
  max-width: 800px;
  width: 100%;
  height: 70px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  margin: 0 auto;

  padding: 16px 48px;

  &:active:not(:disabled) {
    background: var(--color-data-people-background-hover);
  }

  & > svg {
    ${infiniteRotationAnimation('300ms', 'ease')}
  }

  border-radius: 100px;
  background: ${({ disabled }) =>
    disabled ? 'var(--color-data-alumni-background)' : 'var(--color-data-people-background)'};
`;

export const ResourceSubmissionFieldSubmitButtonLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: #000000;
`;

export const ResourceSubmissionFieldInitiativeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column-reverse;
    gap: 8px;
  }
`;

// UNPUBLISH
export const ResourceSubmissionFieldUnpublishWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const ResourceSubmissionFieldUnpublishTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  text-align: center;

  color: #000;
`;

export const ResourceSubmissionFieldUnpublishButton = styled.button`
  width: 100%;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;

  padding: 16px 48px;

  border-radius: 100px;
  border: 2px solid var(--color-error);

  & > svg {
    ${infiniteRotationAnimation('300ms', 'ease')}
  }
`;

export const ResourceSubmissionFieldUnpublishButtonLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  color: #000000;
`;
